import { render, staticRenderFns } from "./HomeUserNotice.vue?vue&type=template&id=f24840ca&scoped=true"
import script from "./HomeUserNotice.vue?vue&type=script&lang=js"
export * from "./HomeUserNotice.vue?vue&type=script&lang=js"
import style0 from "./HomeUserNotice.vue?vue&type=style&index=0&id=f24840ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24840ca",
  null
  
)

export default component.exports